import D2C_Entity from './Entity'
import logger from '@/logger'
import objects from '@/objects'
import store from '@/store'

class D2C_Instance extends D2C_Entity {
  target = 'instance'
  icon = 'microchip'
  static create(props = {}) {
    const Constructor = objects._instancesByType[props.providerType]
    if (Constructor) {
      return new Constructor(props)
    }
    logger.warning(`🚨 Unknown instance type: ${props.providerType}`)
    return new D2C_Instance(props)
  }
  get _hosts() {
    return store.getters.hosts.filter(host => host.instance === this.id)
  }
  get _title() {
    return `${this.memory}GB RAM, ${this.cores} vCPU`
  }
  get _fullTitle() {
    return `${this._title}, ${this.storageSize}GB ${this.storageType}`
  }
}

export default D2C_Instance
